var React = require('react');

function VideoPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 55.5652V20.4348C20 18.9018 21.6539 17.9387 22.9872 18.6954L53.9354 36.2606C55.2858 37.0271 55.2858 38.9729 53.9354 39.7394L22.9872 57.3046C21.6539 58.0613 20 57.0982 20 55.5652Z","fill":"currentColor"}));
}

VideoPlay.defaultProps = {"width":"76","height":"76","viewBox":"0 0 76 76","fill":"none"};

module.exports = VideoPlay;

VideoPlay.default = VideoPlay;
